var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHvacIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 306.3,
    height: 305.2,
    viewBox: "0 0 306.3 305.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.5,14.8c0-9.5-7.8-16.2-17.9-14.6C97.1,8.1,71.4,37.8,71.4,73.1s24.1,65,58.2,72.8c9.5,1.7,17.9-5,17.9-14.6V14.8 L147.5,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.7,290.3c0,9.5,7.8,16.2,17.9,14.6c32.5-7.8,58.2-37.5,58.2-72.8c0-35.8-24.1-65-58.2-72.8c-9.5-1.7-17.9,4.5-17.9,14.6 V290.3L158.7,290.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5,147.5c9.5,0,16.2-7.8,14.6-17.9c-7.8-32.5-37.5-58.2-72.8-58.2s-65,24.1-72.8,58.2c-1.7,9.5,5,17.9,14.6,17.9H291.5 L291.5,147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,159.3c-9.5,0-16.2,7.8-14.6,17.9c7.8,32.5,37.5,58.2,72.8,58.2s65-24.1,72.8-58.2c1.7-9.5-5-17.9-14.6-17.9H14.8 L14.8,159.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvacIcon);
export default __webpack_public_path__ + "static/media/hvac-icon.6049a2b83baf99072b783fb73af5d191.svg";
export { ForwardRef as ReactComponent };